<template>
  <div class="modal" v-if="visible">
      <div class="modal-bg"></div>
      <div class="modal-content" :style="{width:width}">
          <div class="modal-header">
              <span class="fl">{{title}}</span>
              <i class="iconfont icon-danchuangguanbi fs12 cp color-grey" v-if="showClickCancel" @click="confirm"></i>
          </div>
          <div class="modal-warp">
              <slot></slot>
          </div>
          <div class="modal-footer ac" v-show="modalFoot">
              <button class="btn btn-sussess" @click="confirm">{{confirmText}}</button>
              <button class="btn btn-primary-border" v-if="showCancel" @click="confirm">{{cancelText}}</button>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "modal",
  props: {
      visible:{
          type:Boolean,
          default:false
      },
      modalFoot:{
          type:Boolean,
          default:true
      },
      width:{
          type:String,
          default:'400px'
      },
      title:{
          type:String,
          default:'提示'
      },
      confirmText:{
          type:String,
          default:'确定'
      },
      showCancel:{
          type:Boolean,
          default:true
      },
      showClickCancel:{
          type:Boolean,
          default:true
      },
      cancelText:{
          type:String,
          default:'取消'
      },
      questInfo:{
          type:Boolean,
          default:true
      }
  },
  data() {
      return {

      }
  },
  watch:{
      visible:{
          handler(n,o){
              if(n){
                  if(document.getElementById('content')){
                      document.getElementById('content').style.zIndex = '1008';
                  }
                  if(document.getElementById('leftMune')){
                      document.getElementById('leftMune').style.zIndex = '1'
                      document.getElementById('leftMune').style.transition = '0s'
                  }
                  if(document.getElementById('tools')){
                      document.getElementById('tools').style.zIndex = '0'
                  }
              }else{
                  if(document.getElementById('content')){
                      document.getElementById('content').style.zIndex = '1000';
                  }
                  if(document.getElementById('leftMune')){
                      document.getElementById('leftMune').style.zIndex = '11'
                      document.getElementById('leftMune').style.transition = '0.5s'
                  }
                  if(document.getElementById('tools')){
                      document.getElementById('tools').style.zIndex = '1001'
                  }
              }
          }
      }
  },
  mounted() {

  },
  created() {

  },
  methods: {
      confirm (){
          this.$emit('confirm')
      }

}
}
</script>
<style scoped>
  .modal{display:flex;align-items:center;justify-content:center;position:fixed;top:0;left:0;width:100%;height:100%;z-index:99999;animation:fadeIn .2s linear;}
  .modal-bg{width:100%;height:100%;background:rgba(0,0,0,.5);}
  .modal-content{position:absolute;background:#fff;border-radius:4px;}
  .modal-header{height:45px;padding:0 16px;line-height:44px;display:flex;justify-content:space-between;border-bottom:1px solid #ddd;}
  .modal-header .close{width:20px;height:20px;margin:11px 0;}
  .modal-header .close img{margin:4px;}
  .modal-warp{padding:24px;}
  .modal-footer{padding:8px 0 24px;}
  .modal-footer .btn{min-width:92px;margin:0 8px;}
  .modal-warp {
  max-height: 70vh;
  overflow-y: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/versionDialog.vue